import { useState } from "react"
import classnames from "classnames"

import CurrencySwitcherModal, { Currency, currencyLabel } from "./currency_switcher_modal"

import styles from "./currency_switcher.module.scss"

interface Props {
  className?: string
  currencies: Currency[]
  // The currency currently shown in the price selector (the plan's currency). Defaults to USD.
  selectedCode?: string
  onSelect: (code: string) => void
}

export default function CurrencySwitcher({ className, currencies, selectedCode = "usd", onSelect }: Props) {
  const [open, setOpen] = useState(false)

  const selected = currencies.find(currency => currency.code === selectedCode) ?? currencies[0]
  if (!selected) return null

  return (
    <div className={classnames(styles.switcher, className)}>
      <button type="button" className={styles.link} title="Change currency" onClick={() => setOpen(true)}>
        {currencyLabel(selected)}
      </button>
      <CurrencySwitcherModal
        show={open}
        currencies={currencies}
        selectedCode={selected.code}
        onSelect={next => {
          onSelect(next)
          setOpen(false)
        }}
        onClose={() => setOpen(false)}
      />
    </div>
  )
}
